import { useNavigate, useLocation } from "react-router";
import { AppShell } from "@/components/ds";
import { useAuth } from "@/client/hooks/useAuth";
import { LayoutDashboardIcon } from "@/icons/LayoutDashboardIcon";
import { MapPinIcon } from "@/icons/MapPinIcon";
import { UsersIcon } from "@/icons/UsersIcon";
import { CalendarIcon } from "@/icons/CalendarIcon";
import { ClipboardIcon } from "@/icons/ClipboardIcon";
import { CreditCardIcon } from "@/icons/CreditCardIcon";
import type { ReactNode } from "react";
import { BillingBanner } from "./BillingBanner";

const BASE_NAV_ITEMS = [
  { href: "/dashboard", label: "Dashboard", icon: <LayoutDashboardIcon width={18} height={18} /> },
  { href: "/sites", label: "Sites", icon: <MapPinIcon width={18} height={18} /> },
  { href: "/team", label: "Team", icon: <UsersIcon width={18} height={18} /> },
  { href: "/rota", label: "Rota", icon: <CalendarIcon width={18} height={18} /> },
  { href: "/visits", label: "Visits", icon: <ClipboardIcon width={18} height={18} /> },
] as const;

const BILLING_NAV_ITEM = {
  href: "/billing",
  label: "Billing",
  icon: <CreditCardIcon width={18} height={18} />,
} as const;

interface DashboardNavProps {
  readonly children: ReactNode;
}

export function DashboardNav({ children }: DashboardNavProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, membership, billingState } = useAuth();

  function handleLogout() {
    fetch("/api/auth/logout", { method: "POST" }).then(() => {
      navigate("/login");
    });
  }

  const navItems = membership.isOwner
    ? [...BASE_NAV_ITEMS, BILLING_NAV_ITEM]
    : BASE_NAV_ITEMS;

  return (
    <AppShell
      navItems={navItems}
      activeHref={pathname}
      userName={user.name}
      onLogout={handleLogout}
      wide={pathname === "/rota" || pathname.startsWith("/admin")}
      showAdminLink={user.isStaff}
    >
      <BillingBanner billingState={billingState} membership={membership} />
      {children}
    </AppShell>
  );
}
